import { cookieSizeMap } from '../constants/productSizes';

import { getProfileFilterValue } from './getProfileFilterValue';

export function getSizesFromCookies({ cookies, isPdp = false, tldLocale }) {
  const sizes = {};

  Object.entries(cookieSizeMap).forEach(
    ([cookieName, [profileKey, sizeKey]]) => {
      const cookieValue = cookies[cookieName];
      if (cookieValue) {
        const value = getProfileFilterValue({
          profileKey,
          profileValue: cookieValue,
          isPdp,
          tldLocale,
        });
        if (value) {
          sizes[sizeKey] = value;
        }
      }
    }
  );

  return sizes;
}
